import { render } from "./Step5Component.vue?vue&type=template&id=ac062eb4&scoped=true"
import script from "./Step5Component.vue?vue&type=script&lang=js"
export * from "./Step5Component.vue?vue&type=script&lang=js"

import "./Step5Component.vue?vue&type=style&index=0&id=ac062eb4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac062eb4"]])

export default __exports__